module.exports = __webpack_public_path__ + "img/SOUTHASIA_PROCESSED_MEATS.e90097bf.png";